export default __webpack_public_path__ + "static/teal-8415833061f44eb90bb7809090c80990.gif";